<template>
  <step :context="context" image="/images/gift.svg" @back="$emit('back')" @submit="submit">
    <template #guideTitle>Sadakat programınızı beraber kuralım!</template>
    <template #guideDescription>
      <div>
        <b>1. Biriktir ve Harca—</b>Üyelerinize, ziyaret ve harcamalarına karşılık, cazip faydalar sağlayalım.
      </div>
      <div>
        <b>2. Katılım Hediyesi—</b>Misafirlerinizi sadakat programınıza katılmaya teşvik edelim.
      </div>
      <div>
        <b>3. Doğum Günü Hediyesi—</b>Doğum günlerinde üyelerinize sunacağınız bir indirim çeki hem onları mutlu edecektir, hem de satışlarınıza katkı sağlayacaktır.
      </div>
    </template>
    <template #formTitle>Sadakat Programı - Temel Kurgular</template>
    <template #form>
      <v-form class="form" v-model="valid" ref="form">
        <!-- Earn/Redeem -->
        <form-section header="1. Biriktir ve Harca">
          <v-radio-group
            class="mt-0 pt-0"
            v-model="model.earnAndRedeem.value"
            hide-details
            :rules="[rules.required]"
          >
            <custom-radio label="Parapuan Birikimi" value="accumulation" v-slot="{selected}">
              <v-text-field
                class="minimal"
                v-model="model.earnAndRedeem.accumulation"
                suffix="%"
                hide-details
                :rules="selected ? [rules.required, rules.percentage] :  []"
              />
            </custom-radio>
            <div
              class="hint"
            >Örneğin,%10 parapuan kullanıcıya ₺100 alışverişi için ₺10 parapuan kazandıracaktır.</div>
            <div>
              <custom-radio label="Mühürlü Kart" value="punch" v-slot="{selected}">
                <template>
                  <div class="inline ma-0 pa-0">
                    <v-text-field
                      class="minimal"
                      placeholder="5"
                      v-model="model.earnAndRedeem.punch.buy"
                      :rules="selected ? [rules.required, rules.number] : []"
                    />
                    <v-text-field
                      class="minimal-2"
                      placeholder="Ürün Belirtin"
                      v-model="model.earnAndRedeem.punch.items"
                      :rules="[!selected || rules.required]"
                    />
                    <div>alana, </div>
                    <v-text-field
                      class="minimal"
                      placeholder="1"
                      v-model="model.earnAndRedeem.punch.getFree"
                      :rules="selected ? [rules.required, rules.number] : []"
                    />
                    <v-text-field
                      class="minimal-2"
                      placeholder="Ürün Belirtin"
                      v-model="model.earnAndRedeem.punch.getFreeItem"
                      :rules="[!selected || rules.required]"
                    />
                    <div>ikram.</div>
                  </div>
                </template>
              </custom-radio>
            </div>
          </v-radio-group>
        </form-section>

        <!-- Joining Gift Discount -->
        <form-section
          header="2. Katılım Hediyesi - İndirim"
        >
          <div class="inline">
            <div>Lütfen indirim tutarını belirtin</div>
            <v-text-field
              class="minimal"
              prefix="₺"
              placeholder="5"
              v-model="model.joiningGiftDiscount"
              :rules="[rules.required, rules.number]"
            />
          </div>
        </form-section>

        <!-- Birthday Discount -->
        <form-section header="3. Doğum Günü Hediyesi - İndirim" optional>
          <div class="inline">
            <div>Lütfen indirim tutarını belirtin</div>
            <v-text-field
              class="minimal"
              prefix="₺"
              placeholder="5"
              v-model="model.birthdayGiftDiscount"
              :rules="[rules.number]"
            />
          </div>
        </form-section>
      </v-form>
    </template>
  </step>
</template>

<script>
import Step from "../Step";
import FormSection from "../FormSection";
import CustomRadio from "../CustomRadio";

export default {
  props: ["context"],
  components: {
    Step,
    FormSection,
    CustomRadio
  },
  data() {
    return {
      valid: false,
      rules: {
        required: v => !!v || "Field is required",
        number: v => v == null || !isNaN(Number(v)) || "Value must be a number",
        percentage: v =>
          (!isNaN(Number(v)) && v >= 0 && v <= 100) ||
          "Value must be a percentage"
      },
      model: {
        earnAndRedeem: {
          value: null,
          accumulation: null,
          punch: {
            buy: null,
            items: null,
            getFree: null,
            getFreeItem: null
          }
        },
        joiningGiftDiscount: null,
        birthdayGiftDiscount: null,
        ...this.context.submittedData
      }
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate())
        this.$emit("done", { ...this.$data.model });
    }
  }
};
</script>